module.exports = "<p>\n  my-page works!\n</p>\n"